import styled from '@emotion/styled';
import { TextField } from '@mui/material';

const ModelIdField = styled(TextField)({
  maxWidth: 120,
});

export default ModelIdField;
